import axios from 'axios';
import Vue from 'vue';

const version = 'v1';
const getAllPlansApi = `${version}/SubscriptionPlan/getAll`;
const getPlanListApi = `${version}/SubscriptionPlan/getPlanList`;
const deletePlanApi = `${version}/SubscriptionPlan/delete`;
const updatePlanApi = `${version}/SubscriptionPlan/update`;
const addPlanApi = `${version}/SubscriptionPlan/add`;

export const state = Vue.observable({
	plans: [],
	plansList: [],
	plansCount: 0
});

export const mutations = {
	async getPlans() {
		var res = await axios.get(getAllPlansApi);
		state.plans = res.data.result;
	},
	async getPlansList(params = {}) {
		var res = await axios.post(getPlanListApi, params);
		state.plansList = res.data.result.items;
		state.plansCount = res.data.result.totalCount;
	},
	async deletePlan({ id }) {
		await axios.post(deletePlanApi, { id });
		await this.getPlansList();
	},
	async updatePlan(plan) {
		await axios.post(updatePlanApi, plan);
		await this.getPlansList();
	},
	async addPlan(plan) {
		await axios.post(addPlanApi, plan);
		await this.getPlansList();
	},
}
